import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';

import { BehaviorSubject, Observable } from 'rxjs';

import { LoginModel, SecurityInfo, SecurityPrivilege } from '../model/procedure.model';

import { SettingsService } from '../../core/settings/settings.service';

@Injectable({
    providedIn: 'root'
})

export class LoginService {

    appUrl: string;
    apiUrl: string;
    urlStr: string;
    isValid: boolean;
    searchParam: LoginModel;
    searchResult: SecurityInfo;
    warningLabel: string;
    //is
    isClient: boolean = true;
    isEmployee: boolean = false;
    //key
    keyUserType = 'UserType';
    keyCurrentUser = 'CurrentUser';
    keyLogIn = 'login';
    keyNavigateItems = [
        '/' + this.keyLogIn
    ];
    httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json; charset=utf-8'
        })
    };

    prilivages: SecurityPrivilege[];

    user: Observable<SecurityInfo>;
    value: Observable<boolean>;

    private loggedInItem = new BehaviorSubject<boolean>(false);
    private userInfoItem = new BehaviorSubject<SecurityInfo>(new SecurityInfo);

    constructor(
        private http: HttpClient,
        private router: Router,
        public settings: SettingsService,
        @Inject('BASE_URL') private baseUrl: string) {
        this.appUrl = this.baseUrl
        this.apiUrl = this.keyLogIn + '/';
        this.searchParam = new LoginModel();
        this.searchResult = new SecurityInfo();
    }

    initialPermissions(userDetailInfo) {
        this.setLoggedIn();
        this.setUserInfo(userDetailInfo);
        this.prilivages = userDetailInfo.securityPrivileges;
    }
    //has
    hasPermission(requirePermission: string) {
        /*
        let tmpstr:string ='';
     
        if (this.prilivages) {
          for (let i = 0; i < this.prilivages.length; ++i) { 
            if(this.prilivages[i].privilegeName==requirePermission){         
              return true;
            }
          }
        }
        */
        return true;
    }
    //is
    get isLogged() {
        let v: boolean = false;
        let items = this.loggedInItem.asObservable();

        items.subscribe((i: boolean) => { v = i; })

        return v;
    }
    get isLoggedIn() {
        this.value = this.loggedInItem.asObservable();

        return this.value;
    }
    //set
    setLoggedIn() {
        this.loggedInItem.next(true);
    }
    //authenticate
    authenticate(item: LoginModel) {
        let url = this.getURL('Authenticate');
        let items = new HttpParams();

        items = items.set('username', item.username);
        items = items.set('password', item.password);
        items = items.set('software', item.software);

        let data = this.http.get<SecurityInfo>(url,
            {
                params: items
            });

        return data;
    }
    //user
    get userId() {
        let id = 0;

        this.userInfo
            .subscribe(
                (data: any) => {
                    if (data != null) {
                        let items = Object.keys(data);

                        if (items != null) {
                            let count = items.length;

                            if (count > 0) {
                                let key = (this.isEmployee ? 'contact' : 'externalContact') + 'Id';

                                if (items.indexOf(key) > -1) {
                                    id = data[key];
                                }
                            }
                        }
                    }
                });

        return id;
    }
    get userInfo() {
        this.user = this.userInfoItem.asObservable();

        return this.user;
    }
    userData() {
        let last: string = '';
        let first: string = '';
        let position: string = '';
        let info: SecurityInfo = null;

        this.userInfo
            .subscribe((i: SecurityInfo) => {
                info = i;
                last = i.lastName;
                first = i.firstName;
                position = i.position;
            });

        return {
            info: info,
            last: last,
            first: first,
            name: first + ' ' + last,
            position: position
        };
    }
    async userType() {
        let data = await this.http.get(this.getURL(this.keyUserType),
            {
                responseType: 'text'
            });

        return data;
    }
    setUserInfo(val) {
        this.userInfoItem.next(val);
    }
    //url
    getURL(value: string): string {
        return this.appUrl + this.apiUrl + value + '/';
    }
    //do
    login(search: LoginModel): SecurityInfo {
        this.searchParam.username = search.username;
        this.searchParam.password = search.password;

        this.authenticate(this.searchParam).subscribe((data: SecurityInfo) => {
            this.searchResult = data;
            if (data != null) {
                this.isValid = this.searchResult.valid;
            }
            if (this.isValid) {
                localStorage.setItem(this.keyCurrentUser, JSON.stringify(this.searchResult));
                this.loggedInItem.next(true);
                this.userInfoItem.next(this.searchResult);
            }
        },
            error => console.error(error));

        return this.searchResult;
    }
    logout(navigate: boolean = false) {
        this.loggedInItem.next(false);
        localStorage.removeItem(this.keyCurrentUser);
        if (navigate) {
            this.navigate();
        }
    }
    audit(): boolean {
        let ok: boolean;
        let items = this.isLoggedIn;

        items.subscribe((i: boolean) => {
            ok = i;
        });

        let bad: boolean = !ok;

        if (bad) {
            this.logout(bad);
        }

        return ok;
    }
    history(): void {
        let url = window.history.state.prevPage ?? null;

        if (!url) {
            //console.log('page was refreshed!');
            this.logout(true)
        }
    }
    navigate() {
        this.router.navigate(this.keyNavigateItems);
    }

}
